import {IServiceFactory} from "../../service-factory.interface";
import {OrbitMarketingEventAnalyticsCategory} from "../../analytics/analytics.service.interface";

export function onToastButtonClickedAnalytics(services: IServiceFactory, toastId: string | number) {
    const cid = services.user.cid || 'annonymous';
    services.analytics.sendOrbitMarketingEvent(OrbitMarketingEventAnalyticsCategory.Communications, toastId + '_CTA_Click', cid + '_' + Date.now().toString());
}

export function onToastOpenedAnalytics(services: IServiceFactory, toastId: string | number) {
    const cid = services.user.cid || 'annonymous';
    services.analytics.sendOrbitMarketingEvent(OrbitMarketingEventAnalyticsCategory.Communications, toastId + '_Show', cid + '_' + Date.now().toString());
}